import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';
import { formatDateForHasura } from '../utils/dateUtils';

const useTasks = ({ paginated = false } = {}) => {
  const { user } = useAuth();
  const dynamicHook = useDynamicEntity({
    entityType: 'tasks',
    gqlEntityKey: 'tasks',
    queryName: 'GET_TASKS_QUERY',
    createMutation: 'CREATE_TASK_MUTATION',
    updateMutation: 'UPDATE_TASK_MUTATION',
    deleteMutation: 'DELETE_TASK_MUTATION',
    updateVariableName: 'set',
    createVariableName: 'object',
    mutationPattern: 'tasks',
    serverPagination: paginated,
    aggregateKey: paginated ? 'tasks_aggregate' : null,
    transformData: (task) => ({
      ...task,
      taskTitle: task.task_title,
      taskDescription: task.task_description,
      taskStartDate: task.task_start_date ? new Date(task.task_start_date) : null,
      taskDueDate: task.task_due_date ? new Date(task.task_due_date) : null,
      taskStatus: task.task_status,
      firmName: task.firm?.firm_name || '-',
      firmShortName: task.firm?.firm_short_name || '-',
      companyName: task.company?.name || '-',
      createdByUser: task.user ? `${task.user.first_name} ${task.user.last_name}` : '-',
      companyId: task.company_id,
      firmId: task.firm_id,
    }),
    transformFormData: (formData) => ({
      task_title: formData.taskTitle,
      task_description: formData.taskDescription,
      task_start_date: formatDateForHasura(formData.taskStartDate),
      task_due_date: formatDateForHasura(formData.taskDueDate),
      task_status: formData.taskStatus || 'PENDING',
      firm_id: formData.firmId,
      company_id: formData.companyId || user?.companyId,
      created_by: user?.id,
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useTasks };
